import { AtomError } from './error';

export function fatal(code, msg) {
  const err = new AtomError(code || 500, `[atom] ${msg}`, '');
  err.modId = 'jsapi_error';

  console.error(`[atom] ${msg}`);
}

export function error(code, msg) {
  const err = new AtomError(code || 500, `[atom] ${msg}`, '');
  err.modId = 'jsapi_error';

  console.error(`[atom] ${msg}`);
}

export function warn(code, msg) {
  console && console.warn('[invoke api] ', msg, ` \`errCode: ${code}\``);
}
